import React, { memo, useState } from 'react';
import { Stack, Typography, Card, CardContent, Collapse } from 'investira.react.components';
import { InlineInfo, ModalInfo, PessoaImage } from '../../../../components/molecules';
import { EmpresaSetores } from '../../../../components/organisms';
const GrupoSection = memo(props => {
  const {
    pessoa
  } = props;
  console.log('grupo', pessoa.grupo);
  const [expanded] = useState(false);
  const visibleInfos = [{
    label: 'Razão Social',
    value: pessoa.grupo.pessoa,
    copy: 'icon'
  }, {
    label: 'CNPJ',
    value: pessoa.grupo.cnpj,
    variant: 'cnpj',
    copy: 'icon'
  }, {
    label: 'Setores',
    value: pessoa.grupo.top_setor,
    component: ModalInfo,
    modalProps: {
      pessoaId: pessoa.grupo_pessoa_id
    },
    modalContent: EmpresaSetores,
    type: 'row'
  }, {
    label: 'Subsetor',
    value: pessoa.grupo.setor?.setor,
    searchProps: {
      path: '/empresas',
      search: {
        setor_id: pessoa.grupo.setor_id
      }
    }
  }, {
    label: 'CNAE',
    value: pessoa.grupo.setor_id,
    copy: 'icon'
  }, {
    label: 'Companhia Aberta',
    value: pessoa.grupo.cia_aberta ? 'Sim' : 'Não'
  }];
  const hiddenInfos = [];
  return <Stack flexGrow={1} sx={{
    minWidth: '288px'
  }} component="section" aria-label={`Informações da Receita Federal: ${pessoa.pessoa_fantasia || pessoa.pessoa}`}>
      <Card sx={{
      height: '100%'
    }}>
        <CardContent sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}>
          <Stack spacing={2} sx={{
          py: 2
        }}>
            <Stack>
              <Typography variant="subtitle1" color="textPrimary" sx={{
              fontWeight: 600
            }} component="h3">
                Grupo Econômico
              </Typography>
            </Stack>

            <Stack gap={1}>
              <PessoaImage id={pessoa.grupo.logo_pessoa_id} logoPessoaId={pessoa.grupo.logo_pessoa_id} alt={pessoa.grupo.pessoa_fantasia || pessoa.grupo.pessoa} title={pessoa.grupo.pessoa} hasLogo={pessoa.grupo.logo_ok} mercado={'INS'} size={32} />

              <Typography variant="body2" color="textPrimary" sx={{
              fontWeight: 600
            }} component="h4">
                {pessoa.grupo.pessoa_fantasia || pessoa.grupo.pessoa}
              </Typography>
            </Stack>

            <Stack direction="column" sx={{
            gap: 1
          }}>
              {visibleInfos.map(info => {
              const Component = info.component || InlineInfo;
              return <Component key={crypto.randomUUID()} {...info} />;
            })}

              <Collapse in={expanded}>
                <Stack direction="column" spacing={1}>
                  {hiddenInfos.map((info, index) => <InlineInfo key={index} {...info} />)}
                </Stack>
              </Collapse>

              {/* <Button
                onClick={toggleExpand}
                size="small"
                variant="outlined"
                disableElevation
                sx={{
                  fontSize: "0.7rem",
                  padding: "3px 8px",
                  alignSelf: "flex-end",
                }}
               >
                {expanded ? "Mostrar menos" : "Mostrar mais"}
               </Button> */}
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>;
});
export default GrupoSection;
